<template>
  <div v-if="loadingEnd" class="row m-0" id="inicio">
    <div class="col-12 mb-4">
      <h1 class="title font-weight-bold text-uppercase">
        Minha carteira
      </h1>
      <div class="d-flex justify-content-end">
        <b-button 
          class="mr-3" 
          variant="danger"
          @click="$refs.videoManual.toggleOpen({ 
            url: 'https://www.youtube.com/watch?v=e0vlhg0eMHs&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=19', 
            title: 'Minha carteira' 
          })"
        >
          <i class="fas fa-play mr-1"></i>
          Ver video
        </b-button>
        <a class="btn btn-success" href="https://api.construp.com.br/assets/Minha carteira.pdf" target="_blank" download><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a>
      </div>
      <hr class="linha-amarela" />
    </div>
    
    <div class="col-md-12 mb-2">
      <div class="card">
        <h3 class="text-center p-2">Meus recebimentos Iugu</h3>
      </div>
    </div>
    <div 
      v-if="hasPermission()" 
      class="col-md-3"
    >
      <div class="card">
        <div class="card-header">
          <h4>Dias para receber</h4>
        </div>
        <div class="card-body d-flex">
          <input type="number" class="form-control w-25" v-model="dataDays.days" placeholder="Ex: 7">
          <b-button 
          variant="success"
            class="ml-2 w-75"
            @click="saveOrUpdate()"
          >Salvar</b-button>
        </div>
      </div>
    </div>
    <div :class="hasPermission() ? 'col-md-3' : 'col-md-4'">
      <div class="card">
        <div class="card-header">
          <h4>Disponível</h4>
        </div>
        <div class="card-body">
          <span v-if="response.message">{{ response.message.balance }}</span>
        </div>
      </div>
    </div>
    <div :class="hasPermission() ? 'col-md-3' : 'col-md-4'">
      <div class="card">
        <div class="card-header">
          <h4>Disponível para saque</h4>
        </div>
        <div class="card-body">
          <span v-if="response.message">{{ response.message.balance_available_for_withdraw }}</span>
        </div>
      </div>
    </div>
    <div :class="hasPermission() ? 'col-md-3' : 'col-md-4'">
      <div class="card">
        <div class="card-header">
          <h4>Total recebido</h4>
        </div>
        <div class="card-body">
          <span v-if="response.message && response.message.receivable_balance">{{ response.message.receivable_balance }}</span>
        </div>
      </div>
    </div>
    <div class="col-12 mt-4" v-if="response.message && response.message.last_verification_request_status == null">
      <div class="card">
        <div class="card-header">
          <h5>Conta precisa ser validada</h5>
        </div>
          <div class="card-body">
            <button class="btn btn-success" @click="validationScreen()">Clique aqui para validar</button>
          </div>
      </div>
    </div>

    <!-- DEIXAR COMENTADO POR ENQUANTO - PEDIDO DO ADAUTO -->

    <!-- <div class="col-12 mt-4">
      <div class="card">
        <div class="card-header">
          <h5>Conta de recebimento</h5>
        </div>
          <div class="card-body">
            <div class="row">
              <div class="col-3">
                <label>Banco:</label>
                <select v-model="fields.bank" class="form-control" v-if="response.verification && response.verification.length == 0">
                  <option v-for="option in data.options" v-bind:value="option.value">
                    {{ option.text }}
                  </option>
                </select>
                <input type="text" class="form-control" v-model="fields.bank" v-else>
              </div>
              <div class="col-3">
                <label>Número da agencia:</label>
                <input type="text" class="form-control" v-model="fields.agency" placeholder="####">
              </div>
              <div class="col-3">
                <label>Número da conta:</label>
                <input type="text" class="form-control" v-model="fields.account" placeholder="#####-#">
              </div>
              <div class="col-3" v-if="response.verification && response.verification.length == 0">
                <label>Tipo da conta</label>
                <select v-model="fields.account_type" class="form-control">
                  <option v-for="option in accounts" v-bind:value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </div>
              <div class="col-12">
                <button 
                  class="btn btn-success col-12 mt-4"
                  :disabled="response.verification && response.verification.length > 0"
                  @click="saveBank()"
                >Salvar</button>
              </div>
            </div>
          </div>
      </div>
    </div> -->

    <div class="col-12 mt-4">
      <div class="card">
        <div class="card-header">
          <h5>Saque</h5>
        </div>
          <div class="card-body">
            <label for="saque">Digite o valor para saque (valor minimo R$ 5,00)</label>
            <input 
              v-model="value" 
              class="form-control" 
              type="text" 
              v-mask="['#####,##','####,##', '###,##','##,##','#,##']"
              id="saque" 
              placeholder="Ex: 500,00" 
            >        
            <button 
              class="btn btn-success col-12 mt-4"
              @click="withdrawAccount()"
            >Saque</button>
              <!-- :disabled="response.verification && response.verification.length == 0" -->
          </div>
      </div>
    </div>

    <!-- CADERNETA -->
    <div v-if="methodPaymentShopkeeper" class="col-12 mt-4">
      <div class="card"> 
        <div class="card-header p-2">
          <h3 class="text-center">Meus recebimentos via caderneta</h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div :class="desativarComissao ? 'col-md-6' : 'col-md-4'">
              <div class="card">
                <div class="card header pl-2">
                  <h4>Total a receber dos clientes</h4>  
                </div>
                <div class="body p-3">
                  <span v-if="valuesWallet.toReceive > 0"> R$ {{formatMoneyUn(valuesWallet.toReceive)}} </span>
                  <span v-else>R$ 0,00</span>
                </div>
              </div>
            </div>
                   
            <div :class="desativarComissao ? 'col-md-6' : 'col-md-4'">
              <div class="card">
                <div class="card header pl-2">
                  <h4>Faturado nos últimos 30 dias</h4>  
                </div> 
                <div class="body p-3">
                  <span v-if="valuesWallet.receive > 0"> R$ {{formatMoneyUn(valuesWallet.receive)}} </span>
                  <span v-else>R$ 0,00</span>
                </div>
              </div>
            </div>
           
            <div class="col-md-4" v-if="!desativarComissao">
              <div class="card">
                <div class="card header pl-2">
                  <h4>Total a pagar a Constr Up</h4>  
                </div>
                <div class="body p-3">
                  <span v-if="valuesWallet.rateTotal > 0"> R$ {{formatMoneyUn(valuesWallet.rateTotal)}} </span>
                  <span v-else>R$ 0,00</span>
                </div>
              </div>
            </div>
        
          </div>

          <div v-if="!desativarComissao">
            <button 
              class="btn btn-success col-12 mt-4" 
              @click="showModal()"
            >
              Pagar Constr Up
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- DADOS DA CONTA E PEDIDO DE SAQUE -->
    <div 
      class="col-12 mt-4" 
      v-if="fields.bank !== '' || fields.agency !== '' ||
      fields.account !== ''
    ">
      <div class="card">
        <div class="card-header">
          <h3 class="text-center p-2">Meus dados bancários para recebimento</h3>
        </div>
          <div class="card-body">
            <div class="row">
              
              <div class="col-md-3">
                <div class="card">
                  <div class="card-header">
                    <h4>Banco</h4>
                  </div>
                  <div class="card-body">
                    <span>{{ fields.bank }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="card">
                  <div class="card-header">
                    <h4>Número da agencia:</h4>
                  </div>
                  <div class="card-body">
                    <span>{{ fields.agency }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="card">
                  <div class="card-header">
                    <h4>Número da conta:</h4>
                  </div>
                  <div class="card-body">
                    <span>{{ fields.account }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="card">
                  <div class="card-header">
                    <h4>Tipo de conta:</h4>
                  </div>
                  <div class="card-body">
                    <span>{{ fields.account_type }}</span>
                  </div>
                </div>
              </div>  
            </div>

            <div class="row mt-3" v-if="dataTransfer.values.length > 0">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-header">
                    <h5 class="text-center p-2">Meus ultimos 15 saques</h5>
                  </div>
                  <div class="card-body">
                    <b-table
                      responsive
                      striped
                      hover
                      :items="dataTransfer.values"
                      :fields="dataTransfer.header"
                    >
                      <template #cell(created_at)="data">
                        {{ formatDate(data.item.created_at) }}
                      </template>

                      <template #cell(description)>
                        <span>Solicitação de transferência</span>
                      </template>

                      <template #cell(status)="data">
                        {{ verifyStatusTransfer(data.item.status) }}
                      </template>

                      <template #cell(updated_at)="data">
                        {{ formatDate(data.item.updated_at) }}
                      </template>

                      <template #cell(amount)="data">
                        {{ data.item.amount }}
                      </template>
                    </b-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>


    <!-- Modal CADERNETA -->
    <b-modal ref="my-modal" hide-footer title="Pagamento ConstrUp">  
      <div class="row mt-3">
        <div class="col">
          <label for="method">Escolha o meio de pagamento</label>
         <v-select
          v-if="!viewPayment" 
            id="method"
            label="name"
            placeholder="Escolha a opção"
            v-model="payment"
            :options="optionPayment"
         >
          <div slot="no-options">Tipo inválido</div>
         </v-select>
         
         <input  
          v-else 
          class="form-control" 
          type="text" 
          v-model="viewPayment"
          disabled
        >
        </div>
        
        <div class="col">
          <label for="wallet">Valor a pagar</label>
          <br>
          <span v-if="valuesWallet.rateTotal > 0" class="badge badge-info fs-18">
            R$ {{ formatMoneyUn(valuesWallet.rateTotal) }}
          </span>
          <span v-else class="badge badge-info fs-18">
            R$ 0,00
          </span>
        </div>
      </div>

      <!-- Mandar para criar uma ordem de compra iugu -->
      <div class="mt-4 d-flex justify-content-end">
        <button
          v-if="!viewPayment"
          class="btn btn-primary" 
          @click="submitInvoice()"
        >
        Continuar
        </button>
      </div>

      <div class="row mt-4">
        <div class="col-12">

          <!-- cartão -->
          <div v-if="viewPayment =='credit_card'">
            <h5 class="text-center">Pagamento por cartão de crédito</h5>
            
            <div class="col-6">
              <div class="card-wrapper mb-3"></div>
            </div>
            <div id="cc-form" class="col-12 mb-3">
              <div class="row">
                <div class="col-12">
                  <label for="email">Número cartão</label>
                  <input
                    class="form-control mb-3"
                    id="cc-number"
                    type="text"
                    name="number"
                    v-model="card.number"
                    placeholder="xxxx - xxxx - xxxx - xxxx"
                    v-mask="'####-####-####-####'"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label for="email">Primeiro nome</label>
                  <input
                    class="form-control mb-3"
                    id="ccName"
                    type="text"
                    name="ccName"
                    v-model="card.ccName"
                    placeholder="Digite o seu nome"
                  />
                </div>
                <div class="col-6">
                  <label for="email">Último nome</label>
                  <input
                    class="form-control mb-3"
                    id="last-name"
                    type="text"
                    name="last-name"
                    v-model="card.lastname"
                    placeholder="Digite o seu sobrenome"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label for="email">Mês de expiração</label>
                  <input
                    class="form-control mb-3"
                    id="cc-expiration"
                    type="text"
                    name="expiry"
                    v-model="card.month"
                    placeholder="xx"
                    maxlength="2"
                  />
                </div>
                <div class="col-4">
                  <label for="email">Ano de expiração</label>
                  <input
                    class="form-control mb-3"
                    id="cc-expiration"
                    type="text"
                    name="expiry"
                    v-model="card.year"
                    placeholder="xxxx"
                    maxlength="4"
                  />
                </div>
                <div class="col-4">
                  <label for="email">CVV/CVC</label>
                  <input
                    class="form-control mb-3"
                    id="cc-cvv"
                    type="text"
                    name="cvc"
                    v-model="card.cvv"
                    placeholder="xxx"
                    maxlength="4"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <label>Quantidade de parcelas</label>
                  <input
                    class="form-control mb-3"
                    v-model="card.parcel"
                    disabled
                  >
                </div>
              </div>
              <button class="mt-3 btn btn-success btn-block" @click="paymentCard()">Realizar pagamento</button>
            </div>
          </div>

          <!-- pix -->
          <div v-if="viewPayment=='pix'">
            <h5 class="text-center">Pagamento por Pix</h5>
            <div >
              <div class="card-body d-flex justify-content-center align-items-center">
                <qrcode-vue :value="responseInvoice.pix.qrcode_text" :size="size" level="H" />
              </div>
              <div class="card-footer text-center">
                <b-button class="btn-success mb-2" @click="copyToClipboard()">Clique aqui para copiar</b-button>
                <div class="col-12">
                  <span class="mt-4" v-if="copy">{{ this.copy }}</span>
                </div>
              </div>
            </div>

          </div>

          <!-- transferencia -->
          <div v-if="viewPayment=='transfer'">
            <h5 class="text-center">Transferência</h5>
            <button @click="transferIugu()" class="mt-3 btn btn-success btn-block">Realizar pagamento</button>
          </div>
        
        </div>
      </div>
      
      <div class="modal-footer mt-3">
        <button class="btn btn-danger col-5" @click="hideModal">Fechar</button>
      </div>
    </b-modal>
    <VideoManual ref="videoManual"/>
  </div>
</template>

<script type="text/javascript" src="https://js.iugu.com/v2"></script>
<script>
import makeToast from '../../mixins/makeToast';
import QrcodeVue from 'qrcode.vue';
import { mapActions, mapState } from 'vuex';
import validateCpfCnpj from '../../utils/validateCpfCnpj'
import VideoManual from '@/components/VideoManual.vue';
import shopkeeperAppApi from '@/api/shopkeeperAppApi';
import ShopkeepersEnum from '@/enums/ShopkeepersEnum';

export default {  
  name: 'iugu-dash',
  data() {
    return {
      ShopkeepersEnum,
      value: '',
      response: [],
      valuesWallet:'',
      viewPayment:'',
      loadingEnd: false,
      desativarComissao: false,
      card:{
        number: '',
        ccName: '',
        lastname: '',
        month: '',
        year: '',
        cvv: '',
        token: '',
        parcel: 1,
      },
      optionPayment:[{
          method: "pix",
          name: "Pix"
        },
        {
          method: "credit_card",
          name: "Cartão" 
        },
        {
          method: "transfer",
          name: "Transferência via Iugu"
        }  
      ],
      payment: '',
      dataDays: {
        days: 0,
        id: null
      },
      methodPaymentShopkeeper: false,
      withdraw: [],
      responsePayment:[],
      responseInvoice:[],
      valuePix:'',
      copy: '',
      size: 250,
      dataBank: [],
      dataTransfer: {
        values: [],
        header: [
          {
            key: 'created_at',
            label: 'Data solicitação',
            sortable: false
          },
          {
          key: 'description',
          label: 'Descrição',
          sortable: false
          },
          {
            key: 'amount',
            label: 'Valor',
            sortable: false
          },
          {
            key: 'status',
            label: 'Status',
            sortable: false
          },
          {
            key: 'updated_at',
            label: 'Data da transferência',
            sortable: false
          },
        ]
      },
      fields: {
        bank: "",
        agency: "",
        account: "",
        account_type: ""
      },
      accounts: [
        {value:"", text:"-- Selecione --"},
        {value:"cc", text:"Conta Corrente"},
        {value:"cp", text:"Conta Poupança"}
      ],
      data: {
        options: [
          {value:"", text:"-- Selecione um banco --"},
          {value:"001", text:"Banco do Brasil"},
          {value:"033", text:"Santander"},
          {value:"104", text:"Caixa Econômica"},
          {value:"237", text:"Bradesco"},
          {value:"237", text:"Next"},
          {value:"341", text:"Itaú"},
          {value:"041", text:"Banrisul"},
          {value:"748", text:"Sicredi"},
          {value:"756", text:"Sicoob"},
          {value:"077", text:"Inter"},
          {value:"070", text:"BRB"},
          {value:"085", text:"Via Credi"},
          {value:"655", text:"Neon/Votorantim"},
          {value:"260", text:"Nubank"},
          {value:"290", text:"Pagseguro"},
          {value:"212", text:"Banco Original"},
          {value:"422", text:"Safra"},
          {value:"746", text:"Modal"},
          {value:"021", text:"Banestes"},
          {value:"136", text:"Unicred"},
          {value:"274", text:"Money Plus"},
          {value:"389", text:"Mercantil do Brasil"},
          {value:"376", text:"JP Morgan"},
          {value:"364", text:"Gerencianet Pagamentos do Brasil"},
          {value:"336", text:"Banco C6"},
          {value:"218", text:"BS2"},
          {value:"082", text:"Banco Topazio"},
          {value:"099", text:"Uniprime"},
          {value:"197", text:"Stone"},
          {value:"707", text:"Banco Daycoval"},
          {value:"633", text:"Rendimento"},
          {value:"004", text:"Banco do Nordeste"},
          {value:"745", text:"Citibank"},
          {value:"301", text:"PJBank"},
          {value:"97", text:"Cooperativa Central de Credito Noroeste Brasileiro"},
          {value:"084", text:"Uniprime Norte do Paraná"},
          {value:"384", text:"Global SCM"},
          {value:"403", text:"Cora"},
          {value:"323", text:"Mercado Pago"},
          {value:"003", text:"Banco da Amazonia"},
          {value:"752", text:"BNP Paribas Brasil"},
          {value:"383", text:"Juno"},
          {value:"133", text:"Cresol"},
          {value:"173", text:"BRL Trust DTVM"},
          {value:"047", text:"Banco Banese"},
          {value:"208", text:"Banco BTG Pactual"},
          {value:"613", text:"Banco Omni"},
          {value:"332", text:"Acesso Soluções de Pagamento"},
          {value:"273", text:"CCR de São Miguel do Oeste"},
          {value:"093", text:"Polocred"},
          {value:"355", text:"Ótimo"},
          {value:"121", text:"Agibank"},
          {value:"037", text:"Banpará"},
          {value:"380", text:"Picpay"},
          {value:"125", text:"Banco Genial"},
          {value:"412-x", text:"Banco Capital S.A"},
          {value:"741", text:"Banco Ribeirão Preto"},
          {value:"461", text:"ASAAS IP"},
          {value:"623", text:"Banco Pa"},
          {value:"735", text:"Neon"},
          {value:"310", text:"VORTX DTVM LTDA"},
          {value:"318", text:"Banco BMG"},
          {value:"450", text:"Fitbank"},
          {value:"174", text:"Pefisa"},
          {value:"451", text:"J17 - SCD S/A"},
          {value:"089", text:"Credisan"},
          {value:"529", text:"Pinbank"}
        ]
      }
    }
  },

  components: {
    QrcodeVue,
    VideoManual
  },

  mixins: [makeToast],

  computed: {
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario
    }),
  },
  mounted() {
    if(this.dadosUsuario.desativar_comissao && this.dadosUsuario.desativar_comissao) {
      this.desativarComissao = true;
    }

    this.$store.dispatch('startLoader');
    let Script = document.createElement('script');
    Script.setAttribute('src', 'https://js.iugu.com/v2');
    document.head.appendChild(Script);
    this.showIugu();
    this.getMethoPayment();
    this.getDays();
  },
  watch: {
    'loadingEnd': function () {
      if(this.loadingEnd){ 
        setTimeout(() => {
          this.endloading();  
        },1000);
      }
    }
  },
  methods: {
    ...mapActions('shopkeeper', [
      'getTaxaWallet',
      'getPaymentMethods',
      'paymentTaxaWallet'
    ]),

    hasPermission(){
      if(this.dadosUsuario.id == ShopkeepersEnum.WEBCONSTRUP || 
        this.dadosUsuario.id == ShopkeepersEnum.CARDOSO
      ) return true;
      return false;
    },
    endloading(){
      if(this.loadingEnd) this.$store.dispatch('endLoader');
    },
    withdrawAccount() {
      this.value = this.value.replace(",",".")
      let balance = this.response.message.balance_available_for_withdraw.replace("R$", "");
      balance = parseFloat(balance.replace(/\./g, '').replace(',', '.'));

      if(parseFloat(this.value) < 5){
        this.makeToast('Oops!', 'Valor tem de ser maior de R$ 5,00', 'danger');
        return;
      }

      const data = {
        amount: parseFloat(this.value)
      }

      this.$store.dispatch('withdrawAccount', data).then((resp) => {
        this.withdraw = resp.data;
        this.makeToast('Opa!', 'Solicitação feita com sucesso!', 'success');
        this.showIugu();
      }).catch((error) => {
        this.withdraw = error.response.data;
        this.makeToast('Oops!', 'Ocorreu um erro ao solicitar o saque!', 'danger');
      })
    },
    showIugu() {
      this.$store.dispatch('showInfoDashboard')
      .then((resp) => {
        this.response = resp.data;
        
        this.showTransferIugu(this.response.message.informations);
        if(this.response.message.informations.length > 0){
          this.isBankIugu(this.response.message.informations)
        }
      })
      .finally(() => {
        this.loadingEnd = true; 
      })
    },
    isBankIugu(data){
      data.forEach(element => {
        if(element.key == "account_type"){
          this.fields.account_type = element.value;
        }
        if(element.key == "bank"){
          this.fields.bank = element.value;
        }
        if(element.key == "bank_ag"){
          this.fields.agency = element.value;
        }
        if(element.key == "bank_cc"){
          this.fields.account = element.value;
        }
      });
    },
    saveBank() {
      var f = this.fields;
      if(f.bank == '' || f.agency == '' || f.account == '' || f.account_type == '') {
        this.makeToast('Oops!', 'Informe todos os campos em conta de recebimento!', 'danger');
        return;
      }

      if(this.loadingEnd){
        this.$store.dispatch('startLoader');
      }
      this.$store.dispatch('saveBankShop', this.fields)
      .then((resp) => {
          this.makeToast('Sucesso!', 'Conta cadastrada com sucesso!', 'success')
          this.showIugu();
      })
      .catch(() => {
        this.makeToast('Oops!', 'Verifique se os dados estão corretos e tente novamente!', 'danger')
      })
      .finally(() => {
        this.endloading();
      })
    },
    validationScreen() {
      this.$router.push({ name: 'lojista-iugu-validation' });
    },

    showModal() {
      if(this.valuesWallet.rateTotal < 1){
        this.makeToast(
          'Oopss!',
          'Valor menor que R$ 1,00 não é possivél realizar o pagamento',
          'danger'
        );
        return
      }
     
      if(validateCpfCnpj('cnpj', this.dadosUsuario.cnpj)==false){
        this.makeToast(
          'Erro',
          'CNPJ não é válido, favor verificar!',
          'danger'
        );
        return
      }
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.cleanData();
      this.$refs['my-modal'].hide()
    },
    cleanData(){
      this.viewPayment='',
      this.card.number= '',
      this.card.ccName= '',
      this.card.lastname= '',
      this.card.year= '',
      this.card.month= '',
      this.card.cvv= '',
      this.card.token= '',
      this.payment = "";
    },
    paymentCard() {
      Iugu.setAccountID('5F983047944445BEBF92780DA8970D3F');
      Iugu.setup();
      Iugu.setTestMode(false);
      const cc = Iugu.CreditCard(
        this.card.number,
        this.card.month,
        this.card.year,
        this.card.ccName,
        this.card.lastname,
        this.card.cvv
      );
      
      Iugu.createPaymentToken(cc, (response) => {
        if (response.errors) {
          this.makeToast('Oops!', 'Não foi possível salvar o cartão', 'danger');
        } else {
          if(this.loadingEnd){
            this.$store.dispatch('startLoader');
          }
          const data = {
            invoice_id: this.responseInvoice.id,
            token: response.id,
            months: this.card.parcel,
            shop_id: this.dadosUsuario.id 
          };
          this.$store.dispatch('sendCc', data).then((resp) => {
            if (resp.data.message === 'Fatura paga com sucesso!') {
              this.paymentTaxaShopkeeper();
              this.endloading();
              this.getTaxa();
              this.hideModal();
              this.makeToast(
                'Opa!',
                'Pagamento realizado com sucesso!',
                'success'
              );
            } else {
              this.endloading();
              this.makeToast(
                'Oops!',
                'Houver um problema ao realizar o pagamento.',
                'danger'
              );
            }
          });
          this.card.token = response.id;
        }
      });
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.responseInvoice.pix.qrcode_text);
      this.copy = 'Copiado com sucesso!'
    },
    showTransferIugu(){
      this.$store.dispatch('listTransferIugu', this.dadosUsuario.id)
      .then((resp) => {
        this.dataTransfer.values = resp.data.items;
      })
      .finally(() => {
        this.loadingEnd = true; 
      })
    },
    verifyStatusTransfer(value){
      if(value == "pending"){
        return "Pendente"
      }else if(value == "accepted"){
        return "Transferência realizada"
      }
    },
    formatDate(date){
      return new Date(date).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
    },
   transferIugu(){
    if(this.loadingEnd){
      this.$store.dispatch('startLoader');
    }
    const data = {
      amount_cents: this.valuesWallet.rateTotal*100,
      shop_id: this.dadosUsuario.id,
      option_payment: 'trasfer',
      day:'30',
    }

    this.$store
      .dispatch('transferIuguAccount', data)
      .then((response) => {
        if(response.data.id) {
          this.paymentTaxaShopkeeper();
        }
        this.hideModal();
        this.makeToast('Opa!', 'Transferência feita com sucesso', 'success');
        this.getTaxa();
      })
      .catch((error) => {
        this.makeToast(
          'Oopss!',
          'Houve um problema ao realizar a transferência, favor tentar novamente!',
          'danger'
        );
      })
      .finally(() => this.endloading());
    },

    submitInvoice() {
      if(!this.payment){
        this.makeToast(
          'Oopss!',
          'Favor selecionar um meio de pagamento!',
          'danger'
        );
        return
      }
      
      if(!this.valuesWallet.rateTotal || this.valuesWallet.rateTotal < 1){
        this.makeToast(
          'Oopss!',
          'Não é possivél gerar fatura para pagamento com valor menor que R$ 1,00!',
          'danger'
        );
        return
      }

      if(this.payment.method == 'transfer'){
        
        let saldo = this.response.message.balance.replace("R$ ", "")
        saldo = saldo.replace(",",".")
        saldo = parseFloat(saldo)

        if(saldo < this.valuesWallet.rateTotal){
          this.makeToast(
            'Oopss!',
            'Seu saldo não é suficiente para fazer a transferência!',
            'danger'
          );
          return
        }

        this.viewPayment = this.payment.method;
        return
      }

      const items = [];
      const taxa = {
        description: 'PAGAMENTO DE TAXA PARA CONSTRUP',
        quantity: 1,
        price_cents: this.valuesWallet.rateTotal*100,
      }

      items.push(taxa)

      const data = {
        name: this.dadosUsuario.nome_usuario,
        option_payment: this.payment.method,
        email: this.dadosUsuario.email,
        cpf: this.unsMaskValor(this.dadosUsuario.cnpj).toString(),
        phone: this.unsMaskValor(this.dadosUsuario.informacoes.telefone).toString(),
        street: this.dadosUsuario.informacoes.endereco,
        number: this.dadosUsuario.informacoes.numero,
        district: this.dadosUsuario.informacoes.bairro,
        state: this.dadosUsuario.informacoes.estado.uf,
        city: this.dadosUsuario.informacoes.cidade.nome,
        zipcode: this.unsMaskValor(this.dadosUsuario.informacoes.cep).toString(),
        item: items,
        discount_cents: 0,
        user_id: this.dadosUsuario.id,
        status: 'Aguardando análise',
        day:'30'
      };

      if (this.payment.method != '') {
        if(this.loadingEnd){
          this.$store.dispatch('startLoader');
        }
        this.$store
          .dispatch('invoiceWalletIugu', data)
          .then((response) => {
            this.responseInvoice = response.data.iugu
            this.responsePayment = response.data.wallet;
            this.viewPayment = this.payment.method;
            this.makeToast('Opa!', 'Fatura criada com sucesso', 'success');         
          })
          .catch((error) => {
            this.makeToast(
              'Oopss!',
              'Houve um erro ao realizar o pagamento, tente novamente!',
              'danger'
            );
          })
          .finally(() => this.endloading());
      } else {
        this.makeToast(
          'Oopss!',
          'Favor escolher o meio de pagamento',
          'danger'
        );
      }
    },

    unsMaskValor(valor) {
      return parseInt(String(valor).replace(/[\D]+/g, ''));
    },

    getTaxa(){
      if(this.loadingEnd) {
        this.$store.dispatch('startLoader');
      }
      this.getTaxaWallet(this.dadosUsuario.id)
      .then((response) => {
        let value = response.data[0].rateTotal;
        this.valuesWallet = response.data[0];
        this.valuesWallet.rateTotal = value;
      })
      .catch(() => {
        this.makeToast(
          'Oopss!',
          'Houve um problema ao pegar as taxas, favor tentar novamente!',
          'danger'
        );
      })
      .finally(() => {
        this.endloading();
      });
    },

    formatMoneyUn(value) {
      var money = parseFloat(value);
      return money.toLocaleString('pt-br', {minimumFractionDigits: 2});
    },

    paymentTaxaShopkeeper(){
      const data = {
        "user": this.dadosUsuario.id,
        "valuePayment": this.valuesWallet.rateTotal
      }
      if(this.loadingEnd){
        this.$store.dispatch('startLoader');
      }
      this.paymentTaxaWallet(data)
      .then(() => {})
      .catch(() => {
        this.makeToast(
          'Oopss!',
          'Houve um problema ao dar baixa na taxa!',
          'danger'
          );
      })
      .finally(() => {
        this.endloading();
      });
    },

    getMethoPayment() {
      this.getPaymentMethods(this.dadosUsuario.id)
        .then((response) => {
          response.data.data.forEach(element => {
            if(element.type == 4 && element.enabled == 1)
            this.methodPaymentShopkeeper = true
          });
          if(this.methodPaymentShopkeeper){
            this.getTaxa();
          }
        })
        .catch(() => { })
        .finally(() => {
          this.endloading();
        });
    },
    saveOrUpdate() {
      this.dataDays.id ? this.updateDays() : this.saveDays();
    },
    async saveDays() {
      if(this.loadingEnd){
        this.$store.dispatch('startLoader');
      }
      try { 
        const dataSend = {
          "construp_user_id": this.dadosUsuario.id,
          "days": this.dataDays.days,
        }

        const { data } = await shopkeeperAppApi.post(
          '/empresa/days-transfer-money', dataSend);
        
        if(data.data) this.makeToast('Sucesso','Dia salvo com sucesso','success');
      } catch {
        this.makeToast(
          'Erro',
          'Houve um ao buscar o dia',
          'danger'
        );
      } finally {
        this.endloading();
      }
    },
    async getDays() {
      if(this.loadingEnd){
        this.$store.dispatch('startLoader');
      }
      try { 
        const { data } = await shopkeeperAppApi.get(
          `/empresa/get-days/${this.dadosUsuario.id}`);
        
        this.dataDays = data.data || {};
      } catch {
        this.makeToast(
          'Erro',
          'Houve um erro ao buscar o dia',
          'danger'
        );
      } finally {
        this.endloading();
      }
    },
    async updateDays() {
      if(this.loadingEnd){
        this.$store.dispatch('startLoader');
      }
      try { 
        const { data } = await shopkeeperAppApi.put(
        `/empresa/edit-days-transfer-money/${this.dataDays.id}/${this.dataDays.days}`);

        if(data.data) this.makeToast('Sucesso', 'Dia atualizado com sucesso','success');
        
      } catch {
        this.makeToast('Erro', 'Houve um ao buscar o dia', 'danger');
      } finally {
        this.endloading();
      }
    },
  }
}
</script>